module.exports = __webpack_public_path__ + "media/images/ads/bulk-selection-vertical-01caaa4808b4865e036d3042d255ea3a.png";